import { useContext } from 'react';

import { LayoutContext } from './LayoutContext';

export const useLayoutState = () => useContext(LayoutContext);
